if (!customElements.get('quick-add-inline')) {
  customElements.define(
    'quick-add-inline',
    class QuickAddInline extends HTMLElement {
      constructor() {
        super();
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.sizesContainer = this.querySelector('.quick-add-inline__sizes');
        this.prevArrow = this.querySelector('.quick-add-inline__arrow--prev');
        this.nextArrow = this.querySelector('.quick-add-inline__arrow--next');
        this.addEventListener('click', this.onClick.bind(this));
        if (this.sizesContainer) {
          this.sizesContainer.addEventListener('scroll', this.updateArrows.bind(this));
          new ResizeObserver(this.updateArrows.bind(this)).observe(this.sizesContainer);
        }

        // Belt-and-suspenders: on some products a click that visually lands on
        // a size/arrow button is actually being hit-tested to the card's title
        // link instead (a sibling element, so normal event bubbling through
        // this component can never see or stop it). To guard against that
        // regardless of the exact cause, also intercept clicks at the card
        // level, in the capture phase (before the browser acts on whatever
        // element it thinks was clicked), and redirect based on the click's
        // actual coordinates against this panel's buttons.
        const card = this.closest('.card-wrapper');
        if (card && !card.dataset.quickAddInlineGuarded) {
          card.dataset.quickAddInlineGuarded = 'true';
          card.addEventListener('click', this.onCardCaptureClick.bind(this), true);
        }
      }

      connectedCallback() {
        this.updateArrows();
      }

      onClick(evt) {
        const arrow = evt.target.closest('.quick-add-inline__arrow');
        if (arrow) {
          this.scrollSizes(arrow.classList.contains('quick-add-inline__arrow--next') ? 1 : -1);
          return;
        }

        const button = evt.target.closest('button[data-variant-id]');
        if (!button || button.hasAttribute('disabled') || button.classList.contains('loading')) return;
        this.addToCart(button);
      }

      onCardCaptureClick(evt) {
        if (evt.target.closest('quick-add-inline')) return;

        const hit = this.elementAtPointWithin(evt.clientX, evt.clientY);
        if (!hit) return;

        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation();

        if (hit.classList.contains('quick-add-inline__arrow')) {
          this.scrollSizes(hit.classList.contains('quick-add-inline__arrow--next') ? 1 : -1);
          return;
        }

        if (hit.hasAttribute('disabled') || hit.classList.contains('loading')) return;
        this.addToCart(hit);
      }

      elementAtPointWithin(x, y) {
        const candidates = this.querySelectorAll(
          '.quick-add-inline__size, .quick-add-inline__arrow'
        );
        for (const el of candidates) {
          const r = el.getBoundingClientRect();
          if (x >= r.left && x <= r.right && y >= r.top && y <= r.bottom) return el;
        }
        return null;
      }

      scrollSizes(direction) {
        if (!this.sizesContainer) return;
        const amount = this.sizesContainer.clientWidth * 0.8 * direction;
        this.sizesContainer.scrollTo({ left: this.sizesContainer.scrollLeft + amount, behavior: 'smooth' });
      }

      updateArrows() {
        if (!this.sizesContainer || !this.prevArrow || !this.nextArrow) return;
        const { scrollWidth, clientWidth, scrollLeft } = this.sizesContainer;
        const canScroll = scrollWidth > clientWidth + 1;
        this.prevArrow.classList.toggle('is-visible', canScroll && scrollLeft > 1);
        this.nextArrow.classList.toggle('is-visible', canScroll && scrollLeft < scrollWidth - clientWidth - 1);
      }

      addToCart(button) {
        button.classList.add('loading');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', button.dataset.variantId);
        formData.append('quantity', 1);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(window.routes.cart_add_url, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.setError(button, response.description || response.message);
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'quick-add-inline',
              productVariantId: button.dataset.variantId,
              cartData: response,
            });

            this.cart.renderContents(response);
            if (this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            button.classList.remove('loading');
          });
      }

      setError(button, message) {
        console.error(message);
        button.classList.add('quick-add-inline__size--error');
        setTimeout(() => button.classList.remove('quick-add-inline__size--error'), 1500);
      }
    }
  );
}
